module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-settings-v/bank-account-v/bank-account-v.component.scss
// module id = ./src/app/pages/vendor/my-settings-v/bank-account-v/bank-account-v.component.scss
// module chunks = main